var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpgrade2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 138,
    viewBox: "0 0 128 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_94)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.77 137.23C28.6088 137.23 0 108.86 0 73.9797C0 39.0997 28.6088 10.7197 63.77 10.7197C98.9313 10.7197 127.54 39.0997 127.54 73.9797C127.54 108.86 98.9313 137.24 63.77 137.24V137.23ZM63.77 21.4397C34.5665 21.4397 10.8064 45.0097 10.8064 73.9797C10.8064 102.95 34.5665 126.52 63.77 126.52C92.9736 126.52 116.734 102.95 116.734 73.9797C116.734 45.0097 92.9736 21.4397 63.77 21.4397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1736 16.08H58.3672V0H69.1736V16.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.25 1.43263L96.3281 9.66504L119.297 28.669L126.219 20.4366L103.25 1.43263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.109 9.25441L92.3984 29.1289L100.697 35.9952L117.407 16.1207L109.109 9.25441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7713 32.1604H58.3681V42.8804H63.7713C81.0495 42.8804 95.1119 56.8304 95.1119 73.9704C95.1119 80.4404 93.1261 86.6104 89.4567 91.8004L74.2047 76.7204C74.4366 75.8404 74.5777 74.9204 74.5777 73.9704C74.5777 68.0604 69.7289 63.2504 63.7713 63.2504C57.8136 63.2504 52.9648 68.0604 52.9648 73.9704C52.9648 79.8804 57.8136 84.6904 63.7713 84.6904C64.739 84.6904 65.6765 84.5504 66.5737 84.3104L89.8095 107.28L93.62 103.48C101.543 95.5904 105.908 85.1004 105.908 73.9604C105.908 50.9004 86.997 32.1504 63.7612 32.1504L63.7713 32.1604Z",
    fill: "url(#paint0_linear_305_94)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_305_94",
    x1: 52.9648,
    y1: 69.7304,
    x2: 105.918,
    y2: 69.7304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66140E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E42320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E04E11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_94"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127.53,
    height: 137.23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgrade2);
export default __webpack_public_path__ + "static/media/upgrade2.48cf804c551fb155d3fc351bce11ba71.svg";
export { ForwardRef as ReactComponent };